import React from 'react'
import PropTypes from 'prop-types'
import { Page, Header, ModalConfirmacao } from 'components'
import { Form } from './components/Form'
import { useEditarCadaver } from './hooks/useEditarCadaver'
import useStyles from './EditarCadaver.styles'

export const EditarCadaver = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    cadaver,
    processando,
    setProcessando,
    openAlertDelete,
    setOpenAlertDelete,
    handleDelete,
    params,
  } = useEditarCadaver(props)

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      <div className={classes.formContainer}>
        {/* Renderização direta do Formulário sem Card wrapper (Layout Flattening 🛸🚀) */}
        <Form
          className={classes.form}
          cadaver={cadaver}
          idCaso={route.editar ? cadaver.id_caso : params.idCaso}
          editar={route.editar}
          processando={processando}
          setProcessando={setProcessando}
          onClickExcluir={() => setOpenAlertDelete(true)}
        />
      </div>

      {/* Modal de Confirmação de Deleção Unificado */}
      <ModalConfirmacao
        aberto={openAlertDelete}
        onClose={() => setOpenAlertDelete(false)}
        onConfirm={handleDelete}
        processando={processando}
        titulo="Tem certeza que deseja deletar?"
        confirmarLabel="Confirmar"
        cancelarLabel="Cancelar"
        confirmarColor="error"
      >
        O cadáver - NIC {cadaver.nic} - não poderá mais ser acessado. Tem certeza de que deseja realizar esta operação?
      </ModalConfirmacao>
    </Page>
  )
}

EditarCadaver.propTypes = {
  route: PropTypes.object.isRequired,
}

